module.exports = __webpack_public_path__ + "img/horizontal_4_2_r_pp2_2.4b5014f5.png";